const inventorySession = new Map();

export const getBatchQty = (batch) => {
    if (inventorySession.has(batch.id)) {
        return inventorySession.get(batch.id);
    }

    return Number(batch.currentQty);
};

export const setBatchQty = (batchId, qty) => {
    inventorySession.set(batchId, qty);
};

export const clearInventorySession = () => {
    inventorySession.clear();
};